import { render, staticRenderFns } from "./ODialogActionComp.vue?vue&type=template&id=53e6a7a5&"
import script from "./ODialogActionComp.vue?vue&type=script&lang=js&"
export * from "./ODialogActionComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCardActions})
